import { useState } from "react";
import { useNavigate } from "react-router";
import { api } from "../api";
import { Button } from "./tailwind/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "./tailwind/dialog";

const ArchiveModal = ({
  customer,
  scenario,
  isModalArchiveOpen,
  setIsModalArchiveOpen,
  pageEdit,
}) => {
  const navigate = useNavigate();
  const [isArchiveLoading, setIsArchiveLoading] = useState(false);

  const handleArchiveChatbotConfirmation = async () => {
    setIsArchiveLoading(true);
    try {
      if (scenario) {
        await api.scenario.update(scenario.id, {
          isArchived: true,
          status: "inactive",
        });
        if (scenario.rootNode) {
          await api.whatsappTrigger.update(
            scenario.rootNode.whatsappTrigger.id,
            {
              status: "inactive",
            },
          );
          if (scenario.rootNode.id === customer.automaticReplyNodeId) {
            await api.customer.update(customer.id, {
              automaticReplyNode: { _link: null },
            });
          }
          if (scenario.rootNode.id === customer.whatsappOrderNodeId) {
            await api.customer.update(customer.id, {
              whatsappOrderNode: { _link: null },
            });
          }
        }
      }
      setIsModalArchiveOpen(false);
      setIsArchiveLoading(false);
      if (pageEdit) {
        navigate("/chatbots");
      }
    } catch {
      setIsArchiveLoading(false);
    }
  };

  return (
    <Dialog
      key="dialog_archive"
      open={isModalArchiveOpen}
      onClose={() => setIsModalArchiveOpen(false)}
    >
      <DialogTitle>Archive this chatbot </DialogTitle>

      <DialogBody className="flex-1 overflow-y-auto scrollbar">
        <p>
          Are you sure you want to archive the chatbot <b>{scenario.name}</b>?
        </p>
      </DialogBody>
      <DialogActions>
        <Button
          color="secondaryButton"
          onClick={() => setIsModalArchiveOpen(false)}
          disabled={isArchiveLoading}
          className="min-w-[100px] h-10"
        >
          Cancel
        </Button>
        <Button
          color="primaryButton"
          onClick={() => {
            if (scenario.type === "chatbot") {
              handleArchiveChatbotConfirmation(scenario);
            }
          }}
          className="min-w-[100px] h-10"
          loading={isArchiveLoading}
        >
          Archive
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ArchiveModal;
